<template>
  <div>
    <!-- 编辑、添加界面 -->
    <el-dialog  :title="title" :visible.sync="showDialog" :modal-append-to-body=false width="700px"  v-dialog-drag :destroy-on-close="true" :modal=false  :before-close="cancel">
      <el-form class="formDiv" label-width="120px" ref="form" :model="form" :rules="rules">
        <el-form-item label="收件邮箱:" prop="toMail" style="width: 95%!important;">
          <el-input :autosize="{ minRows: 5}" type="textarea" placeholder="请输入内容" v-model="form.toMail">
          </el-input>
        </el-form-item>
        <el-form-item label="抄送邮箱:" prop="ccMail" style="width: 95%!important;">
          <el-input :autosize="{ minRows: 5}" type="textarea" placeholder="请输入内容" v-model="form.ccMail">
          </el-input>
        </el-form-item>
        <el-form-item style="width: 95%!important;">
          {{'注：可输入多个邮箱，一行为一个邮箱'}}
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="cancel">取消</el-button>
        <el-button size="small" type="primary" class="title" @click="handle">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import { checkEmails} from "@/utils/rules";
import {editEmail} from "@/api/dilivery/email";

export default {
  name: "EditEmailAddress",
  props:['showDialog','selectDetail'],
  data(){
    return{
      title:'更改邮箱信息',
      form:{
        id:'',
        toMail:'',
        ccMail:''
      },
      rules: {
        toMail: [
          {required: true,message: '收件邮箱不能为空', trigger: 'change'},
          {validator: checkEmails, trigger: 'change'}
        ],
        ccMail: [
          {required: true,message: '抄送邮箱不能为空', trigger: 'change'},
          {validator: checkEmails, trigger: 'change'}
        ]
      },
    }
  },
  watch:{
    selectDetail:{
      async handler(newVal){
        if(newVal&&Object.keys(newVal)){
          this.form.id = newVal.id
          this.form.ccMail = newVal.ccMails.join('\n')
          this.form.toMail = newVal.toMails.join('\n')
        }
      },
      immediate:true
    },
  },
  methods:{
    cancel(){
      this.$emit('submit','cancel')
    },
    handle(){
      try{
        this.$refs.form.validate(valid=>{
          if(valid){
            let form = {...this.form,ccMails:[],toMails:[]}
            form.ccMails = this.form.ccMail.split('\n').filter(email => email.trim() !== '')
            form.toMails = this.form.toMail.split('\n').filter(email => email.trim() !== '')
            editEmail(form).then(res => {
              if(res.code === 200){
                this.$messageUi.success('更改邮箱成功')
                this.$emit('submit','confirm')
              }
            }).catch(err => {})
          }else {
            this.$nextTick(() => {
              let err = document.getElementsByClassName('is-error')
              if (err.length) {
                err[0].scrollIntoView({
                  block: 'center',
                  behavior: 'smooth',
                })
              }
            })
            this.$messageUi.error('填写参数不规范，请检查')
          }
        })
      }catch(error){
        console.log(error);
      }
    }
  },

}
</script>

<style scoped>

</style>
